// React and related imports
import React from 'react';

// React Router
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// User Info Context
import { useUserInfo } from './UserInfoProvider';
import { useAuth } from './AuthProvider';

// Role matrix
import { canOpen, homePath } from './roleMatrix';

/**
 * Guards every signed-in page with the role matrix: a page the role may not open shows the unauthorized
 * page, except the dashboard root, which sends the role to its own home (a Sheikh lands on Istifta).
 */
export const RoleProtectedRoute: React.FC = () => {
  const { userInfo, loadingUserInfo } = useUserInfo();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Wait if user is authenticated but user info hasn't loaded yet
  if (loadingUserInfo || (isAuthenticated && !userInfo)) {
    return null;
  }

  const role = userInfo?.role;
  if (canOpen(role, location.pathname)) {
    return <Outlet />;
  }

  const home = homePath(role);
  if (userInfo && location.pathname === '/' && home !== '/') {
    return <Navigate to={home} replace />;
  }

  return <Navigate to="/unauthorized" state={{ from: location }} replace />;
};
